"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const StyledLabel = styled_1.default.label `
  display: block;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  // fix for extra indent from _form.sass
  padding-left: 0;
  text-indent: 0;
  ${({ visuallyHidden }) => visuallyHidden &&
    `
      position: absolute;
      height: 1px;
      width: 1px;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
    `}
`;
function Label({ id, children, isRequired, isRequiredMarker, isNotRequiredMarker, style, visuallyHidden = false }) {
    return (react_1.default.createElement(StyledLabel, { id: id, style: style, visuallyHidden: visuallyHidden },
        children,
        isRequired ? isRequiredMarker : isNotRequiredMarker));
}
exports.default = Label;
exports.defaultConfig = {};
//# sourceMappingURL=label.js.map